<template>
  <el-popover
    placement="bottom-start"
    v-if="options"
    v-model="isOpened"
    popper-class="popper-date-multiple"
    trigger="click">
    <div class="date-multiple-content">
      <el-radio-group v-model="activeTab" class="tabs-nav">
        <el-radio v-if="needShowTab(0)" :class="{'active': activeTab === 0}" :label="0">{{L10n('from-to')}}</el-radio>
        <el-radio v-if="needShowTab(1)" :class="{'active': activeTab === 1}" :label="1">{{L10n('yearly')}}</el-radio>
        <el-radio v-if="needShowTab(2)" :class="{'active': activeTab === 2}" :label="2">{{L10n('quarterly')}}</el-radio>
        <el-radio v-if="needShowTab(3)" :class="{'active': activeTab === 3}" :label="3">{{L10n('monthly')}}</el-radio>
        <el-radio v-if="needShowTab(4)" :class="{'active': activeTab === 4}" :label="4">{{L10n('weekly')}}</el-radio>
      </el-radio-group>
      <el-form>
        <div class="tabs-content">
          <div class="tab tab-1" v-show="activeTab === 0">
            <Calendar ref="calendar" @pick="handleDateRange"/>
          </div>
          <div class="tab tab-2" v-show="activeTab === 1">
            <el-form-item :label="L10n('year')">
              <select-response
                :model.sync="year"
                :data="DSYear"
                :fields="{title: 'id', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
          </div>
          <div class="tab tab-3" v-show="activeTab === 2">
            <el-form-item :label="L10n('year')">
              <select-response
                :model.sync="year"
                :data="DSYear"
                :fields="{title: 'id', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
            <el-form-item :label="L10n('quarter')">
              <select-response
                :model.sync="quarter"
                :data="DSQuarter"
                :fields="{title: 'label', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
          </div>
          <div class="tab tab-4" v-show="activeTab === 3">
            <el-form-item :label="L10n('year')">
              <select-response
                :model.sync="year"
                :data="DSYear"
                :fields="{title: 'id', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
            <el-form-item :label="L10n('month')">
              <select-response
                :model.sync="month"
                :data="DSMonth"
                :fields="{title: 'label', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
          </div>
          <div class="tab tab-4" v-show="activeTab === 4">
            <el-form-item :label="L10n('year')">
              <select-response
                :model.sync="year"
                :data="DSYear"
                :fields="{title: 'id', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
            <el-form-item :label="L10n('week')">
              <select-response
                :model.sync="week"
                :data="DSWeek"
                :fields="{title: 'label', id: 'id'}"
                :clearable="false"
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="date-multiple-footer">
        <button
          type="button"
          class="btn btn-gray"
          @click="clear"
          v-html="L10n('reset')"/>
        <button
          type="button"
          class="btn btn-green"
          :disabled="!activeTab && !dateRange"
          @click="handlerSelect"
          v-html="L10n('select')"/>
      </div>
    </div>
    <div
      slot="reference"
      :class="['grid-filter date-multiple', options.classes, {'is-clear': isClear, 'is-focus': isOpened}]"
      :style="options.styles">
      <el-form-item
        :label="fieldLabel"
        class="material-style"
        :data-filed="title"
      >
        <div :class="`el-input el-input--prefix el-input--suffix el-input--${options.size}`">
          <div class="el-input__inner">{{title}}</div>
          <span class="el-input__prefix">
          <i :class="['el-input__icon', options.icon]"/>
        </span>
          <span class="el-input__suffix" v-if="model" @click.stop="clear">
          <i class="el-input__icon el-icon-circle-close el-input__clear"/>
        </span>
        </div>
      </el-form-item>
    </div>
  </el-popover>
</template>

<script>
import mixins from '../mixins'

export default {
  name: 'FilterDateMultiple',
  mixins: [mixins],
  components: {
    Calendar: () => import('@/components/Form/Calendar/Index.vue')
  },
  props: {
    config: { type: Object },
    place: { type: String, default: 'column' }
  },
  data () {
    return {
      isOpened: false,
      model: '',
      // form
      year: (new Date()).getFullYear(),
      quarter: Math.floor(((new Date()).getMonth()) / 3),
      month: String((new Date()).getMonth()),
      week: 1,
      // content helpers
      activeTab: 0,
      dateRange: '',
      // DataSources
      DSYear: [],
      DSQuarter: [],
      DSMonth: []
    }
  },
  computed: {
    DSWeek () {
      const weeks = this.$moment(new Date(this.year, 0)).weeksInYear()
      return new Array(weeks + 1)
        .fill(null)
        .map((value, index) => {
          const id = index + 1
          const startDate = this.$moment(new Date(this.year, 0)).week(id).startOf('week').format('YYYY/MM/DD')
          return {
            id: id,
            label: `${this.L10n('week')} ${id} (${startDate})`
          }
        })
    },
    isClear () {
      return !(this.model)
    },
    fieldLabel () {
      return this.checkJsTemplate(this.config.label)
    },
    title () {
      if (this.model) {
        return `${this.$moment(this.model[0]).format('YYYY.MM.DD')} - ${this.$moment(this.model[1]).format('YYYY.MM.DD')}`
      } else {
        return this.options.placeholder
      }
    }
  },
  created () {
    // DSYear
    this.DSYear = Array.apply(0, Array(10)).map((item, i) => {
      return { id: this.year - i }
    })
    // DSQuarter
    this.DSQuarter = Array.apply(0, Array(4)).map((item, i) => {
      return { label: `Q${i + 1}`, id: i }
    })
    // DSMonth
    this.DSMonth = this.$moment.monthsShort().map((item, i) => {
      return { label: item, id: String(i) }
    })
  },
  methods: {
    needShowTab (num) {
      return this.options.tabs.some(tabNum => tabNum === num)
    },
    MODEL () {
      return {
        // eslint-disable-next-line
        valueTemplate: '( ${data.field} >= ${data.from} && ${data.field} <= ${data.to})',
        value: '',
        // style
        placeholder: this.L10n('select-date'),
        icon: 'el-icon-date',
        classes: '',
        styles: { minWidth: '22rem' },
        size: '',
        tabs: [0, 1, 2, 3]
      }
    },
    parseConfig (Options) {
      this.handle('parseStart')
      // reset
      this.model = ''
      // update options
      this.options = this.$_.merge(this.MODEL(), this.config.options, Options || {});
      ['placeholder'].forEach(key => {
        this.options[key] = this.checkEs6AndRun(this.options[key])
      })
      this.parseOptionsTemplate()
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      // update model
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      // this.setValue(this.options.value, true)
      this.handle('init')
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model && this.model.length === 2) {
        this.result = this.valueTemplate({
          field: this.config.field,
          from: this.formattedValue(this.model[0]),
          to: this.formattedValue(this.model[1])
        }, this)
        this.resultHuman = this.model
      } else if (this.options.value) {
      }
    },
    // METHODS
    formattedValue (Value) {
      // return `"${this.$moment(Value).format('YYYY-MM-DD')}"`
      return `DateTime(${this.$moment(Value).format('YYYY,MM,DD,HH,mm,ss')})`
    },
    // PUBLIC
    setValue (Val, runAnyway = false) {
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      if (this.options && (this.options.value !== Val || runAnyway)) {
        this.options.value = Val
      }
    },
    // HANDLERS
    emitChange () {
      this.updateRendered()
      this.handle('change')
    },
    /**
     * @name resetField
     * @desc Method for reset field data. It emits, when user click button 'clear-filter'
     */
    resetField () {
      this.clearCalendarData()
      this.updateRendered()
      this.handle('resetField')
    },
    clearCalendarData () {
      this.$refs.calendar.reset()
      this.year = (new Date()).getFullYear()
      this.quarter = 0
      this.month = String((new Date()).getMonth())
      this.model = ''
    },
    clear () {
      this.clearCalendarData()
      this.emitChange()
      this.isOpened = false
    },
    handleDateRange (Value) {
      this.dateRange = (Value) ? this.$_.sortBy(Value) : ''
    },
    handlerSelect () {
      const FORMAT = {
        start: 'YYYY-MM-DDT00:00:00',
        end: 'YYYY-MM-DDT23:59:59'
      }
      // range
      if (this.activeTab === 0) {
        this.model = [
          this.$moment(this.dateRange[0]).format(FORMAT.start),
          this.$moment(this.dateRange[1]).format(FORMAT.end)
        ]
      } else if (this.activeTab === 1) {
        this.model = [`${this.year}-01-01`, `${this.year}-12-31`]
      } else if (this.activeTab === 2) {
        let date = this.$moment('2000-01-01').year(this.year).month(this.quarter * 3)
        this.model = [date.format(FORMAT.start), date.add(2, 'M').endOf('month').format(FORMAT.end)]
      } else if (this.activeTab === 3) {
        let date = this.$moment('2000-01-01').year(this.year).month(this.month)
        this.model = [date.format(FORMAT.start), date.endOf('month').format(FORMAT.end)]
      } else if (this.activeTab === 4) {
        let date = this.$moment('2000-01-01').year(this.year).week(this.week)
        this.model = [date.startOf('week').format(FORMAT.start), date.endOf('weeks').format(FORMAT.end)]
      }
      this.emitChange()
      this.isOpened = false
    },
    handle (Type) {
      this.$emit('handle', {
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    }
  }
}
</script>

<style lang="stylus">
  .tabs-nav {
    display flex
    padding 1rem
  }
  .grid-filter.date-multiple {
    .el-input__inner {
      color #ccc
    }

    &.is-reset {
      .el-input__inner {
        color #495057
      }
    }
  }

  .popper-date-multiple {
    &[x-placement^=bottom] .popper__arrow {
      top -7px
    }
    padding 0
    max-width 48rem

    .el-picker-panel {
      box-shadow none
      border none
      margin 0
      border-radius 0
      width 100%
      &__content{
        margin 0 auto
      }
    }
  }

  .date-multiple-content {
    .tabs-content {
      .tab {
        padding 3rem

        &.tab-1 {
          padding 0
        }

        &.tab-3,
        &.tab-4 {
          display flex
          padding 3rem 2rem

          > div {
            padding 0 1rem
          }
        }
      }
    }

    .date-multiple-footer {
      border-top 1px solid #ccc
      padding .5rem
      text-align right

      .btn {
        margin 0 0 0 .5rem
        min-width 8rem
      }
    }
  }
</style>
